import { render, staticRenderFns } from "./Shitangpf.vue?vue&type=template&id=65656ebb&scoped=true"
import script from "./Shitangpf.vue?vue&type=script&lang=js"
export * from "./Shitangpf.vue?vue&type=script&lang=js"
import style0 from "./Shitangpf.vue?vue&type=style&index=0&id=65656ebb&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65656ebb",
  null
  
)

export default component.exports